var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42105 10.3785V11.2H5.47368C5.70621 11.2 5.89474 11.3791 5.89474 11.6C5.89474 11.8209 5.70621 12 5.47368 12H4H2.52632C2.29379 12 2.10526 11.8209 2.10526 11.6C2.10526 11.3791 2.29379 11.2 2.52632 11.2H3.57895V10.3785C1.5706 10.1779 0 8.56018 0 6.6C0 6.3791 0.188528 6.2 0.421053 6.2C0.653577 6.2 0.842105 6.3791 0.842105 6.6C0.842105 8.2542 2.25874 9.6 4 9.6C5.74126 9.6 7.1579 8.2542 7.1579 6.6C7.1579 6.3791 7.34642 6.2 7.57895 6.2C7.81147 6.2 8 6.3791 8 6.6C8 8.56018 6.42941 10.1779 4.42105 10.3785ZM4 9C5.50915 9 6.73684 7.83369 6.73684 6.4V2.6C6.73684 1.16631 5.50915 0 4 0C2.49085 0 1.26316 1.16631 1.26316 2.6V6.4C1.26316 7.83369 2.49085 9 4 9Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/micIcon.deb6306e4b823378e4e35067a64e5462.svg";
export { ForwardRef as ReactComponent };